// ----------------------------------------------------------------------------
// Component: Value Bar
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_value-bar.scss';
